import React from 'react';

const AlertAccent = ({ title, text, showAlert, children }) => {
  return (
    <>
      {showAlert ? (
        <div className="px-4 py-3 leading-normal text-white bg-orange-500 hover:bg-orange-600 rounded-3xl cursor-pointer" role="alert">
          <p className="font-bold">{title}</p>
          <p>{text}</p>
          {children && children}
        </div>
      ) : null}
    </>
  );
};

export default AlertAccent;
